import { DateFormat, formatDate, isDateString, now } from "common";
import { Report, ReportObject } from "types";
import { ReportFilterOperator, ReportFilterState } from "../components/Reports/CustomReports/ReportFilterState";

export const getReportFilterState = (report: Report): ReportFilterState => {
    const dateFields = new Set(["createdAt", "start"]);
    const reportFilterState: ReportFilterState = {
        context: {
            operator: ReportFilterOperator.EQ,
            value: "report",
        },
    };

    for (const [fieldAndOperator, valueString] of Object.entries(report.filters)) {
        const [field, operator = ReportFilterOperator.EQ] = fieldAndOperator
            .split("[")
            .map((value) => value.replace("]", ""));

        // ValueString could be dayjs object
        // If ValueString is a string we split it into array
        // and filter non-empty strings
        const value =
            typeof valueString === "string" ? valueString.split(",").filter(Boolean) : [formatDate(now(valueString))];

        let formattedValue = dateFields.has(field) ? formatDateValues(value) : value;

        if (report.object === ReportObject.TICKET_REDEMPTION && field === "createdAt") {
            formattedValue = formatCreatedAtEndDate(formattedValue);
        }

        reportFilterState[field] = {
            operator: operator as ReportFilterOperator,
            value: formattedValue,
        };
    }

    return reportFilterState;
};

export const formatCreatedAtEndDate = (value: string[]) => {
    if (value?.[0] && value?.[1]) {
        return [value?.[0], formatDate(value?.[1], DateFormat.DATE_TIME_ISO_END_DATE)];
    }

    return [value?.[0]];
};

export const getPendingRangeFilterKey = (filter: ReportFilterState): string | null => {
    for (const [key, filterItem] of Object.entries(filter)) {
        if (
            filterItem?.operator === ReportFilterOperator.RANGE &&
            Array.isArray(filterItem.value) &&
            (filterItem.value as (string | number | boolean | null)[]).includes(null)
        ) {
            return key;
        }
    }
    return null;
};

export const formatDateValues = ([from, to]: string[] = []) => {
    // Converted date to uniform DATE_ISO string for ReportFilterState
    if (from && to) {
        return [isDateString(from) ? formatDate(from) : from, isDateString(to) ? formatDate(to) : to];
    }

    return [isDateString(from) ? formatDate(from) : from];
};
